'use client';

import { useActionState } from 'react';
import Link from 'next/link';
import { signupWithMagicLink } from '@/app/actions/user/auth/signup';
import Input from '@/components/common/Input';
import SubmitButton from '@/components/common/SubmitButton';
import GoogleOAuthButton from '@/components/common/GoogleOAuthButton';

const UserSignupForm = () => {
  const [state, formAction] = useActionState(signupWithMagicLink, null);

  return (
    <div className="flex flex-col gap-10 w-full max-w-[320px] md:gap-10 md:w-80 md:max-w-none">
      <div className="text-center md:text-left">
        <h1 className="text-2xl font-bold text-mono-100 font-noto-sans-jp leading-[1.4] md:text-[28px]">
          支援者で新規登録
        </h1>
      </div>

      <form action={formAction} className="flex flex-col gap-6 md:gap-6">
        <Input
          id="email"
          name="email"
          type="email"
          label="メールアドレス"
          placeholder="メールアドレスを入力してください"
          required
          error={state?.fieldErrors?.email?.[0]}
          autoComplete="email"
        />

        <div className="text-xs text-mono-60 font-noto-sans-jp md:text-sm">
          登録したメールアドレスに確認リンクを送信します。リンクをクリックして登録を完了してください。
        </div>

        {state?.error && (
          <div className="text-xs text-red-500 font-noto-sans-jp md:text-sm">{state.error}</div>
        )}

        <SubmitButton>登録する</SubmitButton>
      </form>

      {/* Google OAuth */}
      <div className="flex flex-col gap-4">
        <div className="flex items-center gap-4">
          <div className="flex-1 h-px bg-mono-20" />
          <span className="text-sm text-mono-60 font-noto-sans-jp">または</span>
          <div className="flex-1 h-px bg-mono-20" />
        </div>
        <GoogleOAuthButton userType="user" label="Googleで登録" />
      </div>

      <div className="flex flex-col gap-0 items-center md:gap-2">
        <Link
          href="/user/login"
          className="text-base text-mono-80 font-roboto text-center underline hover:text-mono-100 transition-colors leading-[1.4] block md:text-base"
        >
          ログイン
        </Link>
      </div>
    </div>
  );
};

export default UserSignupForm;
